module.exports = __webpack_public_path__ + "img/hr-curved-rail-vertical-left-bottom-backplates.7548598f.png";